import {ReactComponent as celery} from "./allergensIcons/celery.svg";
import {ReactComponent as crustaceans} from "./allergensIcons/crustaceans.svg";
import {ReactComponent as eggs} from "./allergensIcons/eggs.svg";
import {ReactComponent as fish} from "./allergensIcons/fish.svg";
import {ReactComponent as gluten} from "./allergensIcons/gluten.svg";
import {ReactComponent as lactose} from "./allergensIcons/lactose.svg";
import {ReactComponent as lupins} from "./allergensIcons/lupins.svg";
import {ReactComponent as molluscs} from "./allergensIcons/molluscs.svg";
import {ReactComponent as mustard} from "./allergensIcons/mustard.svg";
import {ReactComponent as nuts} from "./allergensIcons/nuts.svg";
import {ReactComponent as peanuts} from "./allergensIcons/peanuts.svg";
import {ReactComponent as sesame} from "./allergensIcons/sesame.svg";
import {ReactComponent as soy} from "./allergensIcons/soy.svg";
import {ReactComponent as sulphurDioxide} from "./allergensIcons/sulphurDioxide.svg";

export const allergensIcons = [
    {
        uid: 'celery',
        icon: celery
    },
    {
        uid: 'crustaceans',
        icon: crustaceans
    },
    {
        uid: 'eggs',
        icon: eggs
    },
    {
        uid: 'fish',
        icon: fish
    },
    {
        uid: 'gluten',
        icon: gluten
    },
    {
        uid: 'lactose',
        icon: lactose
    },
    {
        uid: 'lupins',
        icon: lupins
    },
    {
        uid: 'molluscs',
        icon: molluscs
    },
    {
        uid: 'mustard',
        icon: mustard
    },
    {
        uid: 'nuts',
        icon: nuts
    },
    {
        uid: 'peanuts',
        icon: peanuts
    },
    {
        uid: 'sesame',
        icon: sesame
    },
    {
        uid: 'soy',
        icon: soy
    },
    {
        uid: 'sulphurDioxide',
        icon: sulphurDioxide
    },
]